var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import Styles from './login-styles.scss';
import { loginState, FormStatus, ButtonKV, InputKV } from './components';
import { AuthFooter, AuthHeader, loginFlowUserState, currentAccountState, ButtonBorderedKVBase, DefaultModal, currentUserState } from '@/presentation/components';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import AuthLayout from '@/presentation/components/auth-layout/auth-layout';
import { IconBlock, IconEye, IconEyeSlash, IconKey, IconSupport, IconUser } from '@/presentation/components/icons';
import { getUserRolesInfo, validateRole } from '@/main/utils/role-utils';
import useRouterQuery from '@/presentation/hooks/use-router-query';
import { isMobile, isTablet } from 'mobile-device-detect';
import ButtonSocial from '@/presentation/components/button-kv/button-social';
import { AppleIcon, CleverIcon, GoogleIcon } from '@/presentation/components/icons/socials';
import { Auth } from 'aws-amplify';
import ChooseRole from './choose-role';
import { useSimpleLogout } from '@/presentation/hooks';
import * as Sentry from '@sentry/react';
import usePartner from '@/presentation/hooks/use-partner';
const ALLOW_GROUPS = ['Teacher', 'Client', 'Student'];
const Login = ({ validation, authentication, login }) => {
    // const inoutPassRef = useRef<HTMLInputElement>();
    const resetLoginState = useResetRecoilState(loginState);
    const setUser = useSetRecoilState(loginFlowUserState);
    const [state, setState] = useRecoilState(loginState);
    const { setCurrentAccount } = useRecoilValue(currentAccountState);
    const { setCurrentUser } = useRecoilValue(currentUserState);
    const navigate = useNavigate();
    const query = useRouterQuery();
    const logout = useSimpleLogout();
    const { rootPath } = usePartner({});
    // internal state
    const [showPassword, setShowPassword] = useState(false);
    const validate = (field) => {
        const { email, password } = state;
        const formData = { email, password };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.emailError || !!prev.passwordError })));
    };
    useEffect(() => {
        logout();
    }, []);
    useEffect(() => resetLoginState(), []);
    useEffect(() => {
        if (state.email)
            validate('email');
    }, [state.email]);
    useEffect(() => {
        if (state.password)
            validate('password');
    }, [state.password]);
    useEffect(() => {
        if (query.get('email')) {
            const email = decodeURIComponent(query.get('email'));
            console.log('🚀 ~ file: login.tsx:68 ~ useEffect ~ query.get(email)', email);
            setState(prev => (Object.assign(Object.assign({}, prev), { email })));
        }
    }, [query.get('email')]);
    const handleSubmit = (event) => {
        event.preventDefault();
        // console.table(state);
        try {
            if (state.isLoading || state.isFormInvalid) {
                return;
            }
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            authentication
                .auth({
                email: state.email,
                password: state.password
            })
                .then((user) => {
                var _a;
                // validate group
                const allowGroup = user.challengeName !== 'NEW_PASSWORD_REQUIRED' ? validateRole(ALLOW_GROUPS, user) : true;
                if (allowGroup) {
                    // setState(prev => ({ ...prev, accountExpired: true }));
                    const userRoles = getUserRolesInfo(user);
                    let roleNameWatcher = null;
                    if (((_a = user === null || user === void 0 ? void 0 : user.attributes) === null || _a === void 0 ? void 0 : _a.address) === 'FROM_COGNITO_WATCHER') {
                        roleNameWatcher = userRoles.roles.length > 0 ? userRoles.roles[0] : null;
                    }
                    switch (user.challengeName) {
                        case 'SOFTWARE_TOKEN_MFA':
                            setUser(user);
                            navigate('/mfa-setup');
                            break;
                        case 'MFA_SETUP':
                            setUser(user);
                            navigate('/mfa-setup');
                            break;
                        case 'CUSTOM_CHALLENGE':
                            setUser(user);
                            navigate('/custom-challenge');
                            break;
                        case 'NEW_PASSWORD_REQUIRED':
                            setUser(user);
                            navigate('/new-password-required');
                            break;
                        /*
                          // console.log('🚀 ~ file: login.tsx:131 ~ .then ~ setUser:', validateInvitation(user));
                          // check for expiration
                          setUser(user);
                          if (!validateInvitation(user)) {
                            navigate('/new-password-required');
                          } else {
                            navigate('/expired-invitation');
                          }
          
                          break;
                          */
                        default:
                            if (userRoles.roles.length > 1) {
                                setUser(user);
                                setState(prev => (Object.assign(Object.assign({}, prev), { multiplesRoles: true, isLoading: false })));
                            }
                            else {
                                completeLogin(user, roleNameWatcher);
                            }
                            break;
                    }
                }
                else {
                    setState(prev => (Object.assign(Object.assign({}, prev), { mainError: 'Role is not allowed here', isLoading: false })));
                }
            })
                .catch(err => {
                console.error(err);
                Sentry.captureException(err);
                setState(prev => (Object.assign(Object.assign({}, prev), { mainError: getMessageError(err), isLoading: false })));
            });
        }
        catch (error) {
            Sentry.captureException(error);
            setState(Object.assign(Object.assign({}, state), { isLoading: false, mainError: error.message }));
        }
    };
    /*
  
    const hasPassed24Hours = (previousTimestamp: number): boolean => {
      const currentTimestamp = Math.floor(Date.now() / 1000);
      const secondsIn24Hours = 86400;
  
      const elapsedTime = currentTimestamp - previousTimestamp;
      return elapsedTime >= secondsIn24Hours;
    };
  
    const validateInvitation = (user): boolean => {
      const lastUpdated = user.challengeParam.userAttributes?.updated_at;
      console.log('🚀 ~ file: login.tsx:174 ~ validateInvitation ~ lastUpdated', lastUpdated);
      if (!lastUpdated) return true;
      const previousTimestamp = parseInt(lastUpdated);
      console.log('🚀 ~ file: login.tsx:176 ~ validateInvitation ~ previousTimestamp', previousTimestamp);
      return hasPassed24Hours(previousTimestamp);
    };
    */
    const toggleSP = () => setShowPassword(!showPassword);
    const completeLogin = (user, paramRole) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const loginStatus = yield login.loginStatus(paramRole);
            if (loginStatus.userStatus) {
                if (isMobile || isTablet) {
                    navigate('/mobile-warning');
                    return;
                }
                if (loginStatus.roleName === 'Client') {
                    if (loginStatus.subscriptionStatus) {
                        setCurrentAccount(user);
                        setCurrentUser(loginStatus);
                        navigate('/school-dashboard');
                    }
                    else {
                        setState(prev => {
                            var _a, _b;
                            return (Object.assign(Object.assign({}, prev), { accountExpired: true, isLoading: false, idClientExpired: (_b = (_a = loginStatus === null || loginStatus === void 0 ? void 0 : loginStatus.user) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.id }));
                        });
                    }
                }
                else if (loginStatus.roleName === 'Student') {
                    setCurrentAccount(user);
                    setCurrentUser(loginStatus);
                    if (((_a = loginStatus === null || loginStatus === void 0 ? void 0 : loginStatus.user) === null || _a === void 0 ? void 0 : _a.dateOfBirthday) === null ||
                        ((_b = loginStatus === null || loginStatus === void 0 ? void 0 : loginStatus.user) === null || _b === void 0 ? void 0 : _b.ethnicity) === null ||
                        ((_c = loginStatus === null || loginStatus === void 0 ? void 0 : loginStatus.user) === null || _c === void 0 ? void 0 : _c.gender) === null)
                        navigate('/student-dashboard/first-login');
                    else
                        navigate('/student-dashboard');
                }
                else if (loginStatus.roleName === 'Teacher') {
                    setCurrentAccount(user);
                    setCurrentUser(loginStatus);
                    navigate('/teacher-dashboard');
                }
            }
            else {
                setState(prev => (Object.assign(Object.assign({}, prev), { mainError: 'User inactive', isLoading: false })));
            }
        }
        catch (error) {
            Sentry.captureException(error);
            console.error(error);
            setState(prev => (Object.assign(Object.assign({}, prev), { mainError: getMessageError(error), isLoading: false })));
        }
    });
    const loginWith = (provider) => __awaiter(void 0, void 0, void 0, function* () {
        const response2 = yield Auth.federatedSignIn({
            customProvider: provider
        });
        console.log('response2:', response2);
    });
    return (React.createElement(AuthLayout, null,
        React.createElement(AuthHeader, null),
        React.createElement("div", { className: Styles.loginWrap },
            React.createElement("div", { className: Styles.imgWrap },
                React.createElement("img", null)),
            React.createElement("div", { className: Styles.formWrap }, state.accountExpired || state.multiplesRoles ? (state.accountExpired ? (React.createElement(AccountExpired, null)) : (React.createElement(ChooseRole, { completeLogin: completeLogin }))) : (React.createElement("form", { method: "post", onSubmit: handleSubmit, className: Styles.formClass },
                React.createElement("div", { className: Styles.mainPart },
                    React.createElement("h1", null, "Sign In"),
                    React.createElement(FormStatus, null),
                    React.createElement("div", { className: Styles.inputWrap },
                        React.createElement(InputKV, { type: "email", name: "email", placeholder: "Your Email", label: "EMAIL", leftIcon: React.createElement(IconUser, { width: 24, height: 24 }), required: true, id: "input_login_id" }),
                        React.createElement(InputKV, { required: true, type: showPassword ? 'text' : 'password', name: "password", placeholder: "**********", label: "PASSWORD", leftIcon: React.createElement(IconKey, { width: 24, height: 24 }), rightIcon: showPassword ? (React.createElement(IconEye, { style: { cursor: 'pointer' }, width: 24, height: 24, onClick: toggleSP, color: "#00A3FF" })) : (React.createElement(IconEyeSlash, { style: { cursor: 'pointer' }, width: 24, height: 24, onClick: toggleSP, color: "#00A3FF" })) })),
                    React.createElement("div", { className: Styles.containerBtnLogin },
                        React.createElement(ButtonKV, { type: "submit", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", width: 85, height: 56, testId: "submit" }, 'Login'),
                        React.createElement(Link, { "data-testid": "link-forgot-password", to: "/forgot-password", className: Styles.forgotText }, "Forgot your password?")),
                    React.createElement("div", { className: Styles.containerBtnLogin },
                        React.createElement("div", { className: Styles.boxHr }),
                        React.createElement("div", { className: Styles.continueWith }, "or continue with"),
                        React.createElement("div", { className: Styles.boxHr })),
                    React.createElement("div", { className: Styles.containerBtnLogin2 },
                        React.createElement("div", null,
                            React.createElement(ButtonSocial, { leftIcon: React.createElement(AppleIcon, null), type: "button", height: 45, backgroundColor: "black", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return loginWith('SignInWithApple'); }) }, "Apple")),
                        React.createElement("div", null,
                            React.createElement(ButtonSocial, { leftIcon: React.createElement(GoogleIcon, null), type: "button", height: 45, backgroundColor: "white", color: "black", border: "1px solid #747775", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return loginWith('Google'); }) }, "Google")),
                        React.createElement("div", null,
                            React.createElement(ButtonSocial, { leftIcon: React.createElement(CleverIcon, null), type: "button", height: 45, backgroundColor: "#4274F6", onClick: () => __awaiter(void 0, void 0, void 0, function* () { return loginWith('Clever'); }) }, "Clever")))),
                React.createElement("div", { className: Styles.bottomPart },
                    React.createElement("div", { className: Styles.registerTxt },
                        React.createElement("span", null, "First time user, school, or group?")),
                    React.createElement("div", { className: Styles.registerLink },
                        React.createElement(Link, { "data-testid": "signup-link", to: `${rootPath}choose-plan`, className: Styles.localLinkSign }, "Register Here"))))))),
        React.createElement(AuthFooter, null)));
};
const AccountExpired = () => {
    const navigate = useNavigate();
    const [state, setState] = useRecoilState(loginState);
    const toggleModal = (flag) => setState(prev => (Object.assign(Object.assign({}, prev), { modalOpen: flag })));
    useEffect(() => {
        if (state.idClientExpired > 0) {
            navigate(`/expired/school-upgrade-flow?idClient=${state.idClientExpired}&flexible=true`);
        }
    }, [state.idClientExpired]);
    return (React.createElement("div", { className: Styles.formClass },
        React.createElement("div", { className: Styles.mainPartAE },
            React.createElement("div", null,
                React.createElement(IconBlock, null)),
            React.createElement("h1", null, "Your account has expired"),
            React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => navigate('/renew-subscription') }, "Renew Subscription"),
            React.createElement("div", null,
                "Need help?",
                ' ',
                React.createElement("span", { style: { color: '#FFA800', cursor: 'pointer' }, onClick: () => toggleModal(true) }, "Get Support"))),
        React.createElement(DefaultModal, { open: state.modalOpen, onClose: () => toggleModal(false), showClose: true },
            React.createElement("div", { className: Styles.modalWrap },
                React.createElement("div", { className: Styles.mainPartAE },
                    React.createElement("div", null,
                        React.createElement(IconSupport, null)),
                    React.createElement("h1", { className: Styles.titleSupport }, "Need Help?"),
                    React.createElement("div", { className: Styles.detailSupport }, `Got questions? We've got answers. Check out our how-to guides, and if you need more help, just submit a ticket to our team.`),
                    React.createElement("div", { style: { padding: '1rem' } },
                        React.createElement(ButtonBorderedKVBase, { type: "button", onClick: () => window.open('https://kidvestors.co/help-center', '_blank') }, "Get Help")))))));
};
const getMessageError = (err) => {
    switch (err === null || err === void 0 ? void 0 : err.code) {
        case 'UserNotFoundException':
        case 'NotAuthorizedException':
            return 'Invalid Email or Password';
        default:
            return 'Something went wrong! Try again later';
    }
};
export default Login;
